export default __webpack_public_path__ + "static/media/cs2.7a40d407.jpeg";